import { Transaction } from '@app/models/payroll/company/transaction.model';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

const FAILURE_CODES = {
    '900': 'table.transactions.failureCodes.900',
    '901': 'table.transactions.failureCodes.901',
    '902': 'table.transactions.failureCodes.902',
    '903': 'table.transactions.failureCodes.903',
    '904': 'table.transactions.failureCodes.904',
    '905': 'table.transactions.failureCodes.905',
    '907': 'table.transactions.failureCodes.907',
    '908': 'table.transactions.failureCodes.908',
    '909': 'table.transactions.failureCodes.909',
    '910': 'table.transactions.failureCodes.910',
    '911': 'table.transactions.failureCodes.911',
    '912': 'table.transactions.failureCodes.912',
    '914': 'table.transactions.failureCodes.914',
    '915': 'table.transactions.failureCodes.915',
    '916': 'table.transactions.failureCodes.916',
    '917': 'table.transactions.failureCodes.917',
    '918': 'table.transactions.failureCodes.918',
    '919': 'table.transactions.failureCodes.919',
    '920': 'table.transactions.failureCodes.920',
    '921': 'table.transactions.failureCodes.921',
    '922': 'table.transactions.failureCodes.922',
    '990': 'table.transactions.failureCodes.990',
};

export class FailureCodeColumn extends Column {
    title = 'table.transactions.failureCode';
    type = CellDisplay.string;
    sortable = true;
    sortField = 'failureCode';

    filters = [
        new CheckListFilter(
            'failureCode',
            Object.entries(FAILURE_CODES).map(([code, message]) => ({ label: message, value: code }))
        ),
    ];

    getDisplayPropertyValue(object: Transaction): string {
        return object.failureCode || '-';
    }
}
